import React from 'react';
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import SignupSection from '../components/SignupSection';
import FooterSection from '../components/FooterSection';
import NumberCount from '../components/NumberCount';

function Signup() {
  return (
    <div>
      <Header />
      <PagesHero page={"sign up"} />
      <SignupSection />
      <NumberCount />
      <FooterSection />
    </div>
  )
}

export default Signup;